export const getFullName = (employee) => {
    let fullName;

    if (!employee.firstName || !employee.lastName) {
        return null;
    }

    if (employee.middleName) {
        fullName = `${employee.firstName} ${employee.middleName} ${employee.lastName}`;
    } else {
        fullName = `${employee.firstName} ${employee.lastName}`;
    }

    return fullName;
}
